import { createContext, useContext } from 'react';

// 1 Create the context
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const PageContext = createContext<any>({});

// 2 Create a custom hook to use the context
export const usePageContext = () => {
  return useContext(PageContext);
};
